<template>
  <select
    @change="onChange"
    :value="selected"
    :class="{ 'form-control-sm': size === 'small' }"
    class="form-control custom-select"
  >
    <option v-for="(option, index) in options" :key="index" :value="option.value">
      {{ option.label }}
    </option>
  </select>
</template>

<script>
export default {
  name: "CustomSelect",
  props: {
    options: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
      validator: value => ["default", "small"].includes(value),
    },
  },
  data() {
    return {
      selected: this.active,
    };
  },
  methods: {
    onChange(e) {
      this.selected = e.target.value;
      this.$emit("change", this.selected);
    },
  },
};
</script>
